<div class="background">
<app-website-header></app-website-header>
<div class="main-container">
<div class="header">
    <img src="../../../../../assets/images/about-us-header.jpg" width="100%" height="auto" />
    <div class="header-name">
        <p>How It Works</p>
    </div>
</div>
<div class="sub-container">
    <div class="mission d-flex"  style="padding: 1rem;padding-bottom: 29px;">
        <div class="mission-txt d-flex flex-column justify-content-center" style="flex: 1; margin-left: 48px;">
            <div class="heading">
                Our Mission
            </div>
            <div class="d-flex flex-column content-align" style="margin-top: 5px;">
                <div class="text-block">
                    <span ><img src="/assets/images/right-arrow.svg" alt="Arrow">&nbsp;&nbsp;</span>
                    <div>To revolutionize the health-care industry by providing a premier digital platform for seamless interaction.</div>
                </div>
                <div class="text-block">
                    <span style="margin-right: 5px;"><img src="/assets/images/right-arrow.svg" alt="Arrow">&nbsp;&nbsp;</span>
                    <div>Commit to empowering Manufacturers, Distributors, and Health Care Providers with cutting-edge tools for growth and connectivity.</div>
                </div>
                <div class="text-block">
                    <span style="margin-right: 5px;"><img src="/assets/images/right-arrow.svg" alt="Arrow">&nbsp;&nbsp;</span>
                    <div>Dedicated to fostering a collaborative and vibrant ecosystem where the entire medical community can connect, grow, and thrive together.</div>
                </div>
                <div class="text-block">
                    <span ><img src="/assets/images/right-arrow.svg" alt="Arrow">&nbsp;&nbsp;</span>
                    <div>Foster continuous learning and professional growth through our comprehensive Knowledge Centre.</div>
                </div>
                <div class="text-block">
                    <span style="margin-right: 5px;"><img src="/assets/images/right-arrow.svg" alt="Arrow">&nbsp;&nbsp;</span>
                    <div>Facilitate career advancement by offering a platform for job opportunities and professional networking within the medical industry.</div>
                </div>
            </div>
            
            


        </div>
        <div class="mission-img d-flex justify-content-center align-items-center" style="flex: 1">
            <img src="../../assets/images/about-us-mission.jpg" width="95%" height="auto">
        </div>
    </div>
    <div class="work d-flex flex-column" >
        <div class="heading how-does-it-work-heading" style="margin-bottom: 10px;">How Medworld Expo Operates</div>



        <div class="image-container d-flex flex-row">
            <div class="content-block" >
                <img class="icon" src="../../../../assets/images/icons/create-your-account.svg" width="48px" height="48px">
                <div class="content">
                    <p class="my-2 sub-heading">Create Your Account</p>
                    <p style="color: #05709F;">Sign up and personalize your profile for a tailored experience.</p>
                </div>
            </div>
            <div class="arrow d-flex justify-content-center align-items-center">
                <img src="../../assets/images/icons/about-us-right-icon.svg" class="arrowImage" style="padding-right: 10px;">
            </div>
            <div class="content-block">
                <img class="icon" src="../../../../assets/images/icons/explore-connect.svg" width="48px" height="48px">
                <div class="content">
                    <p class="my-2 sub-heading">Explore & Connect</p>
                    <p style="color: #05709F;">Discover products, services, and partners through advanced search tools.</p>
                </div>
            </div>
            <div class="arrow d-flex justify-content-center align-items-center">
                <img src="../../assets/images/icons/about-us-right-icon.svg" class="arrowImage" style="padding-right: 10px;">
            </div>
            <div class="content-block" >
                <img class="icon"src="../../../../assets/images/icons/engage-collaborate.svg" width="48px" height="48px">
                <div class="content">
                    <p class="my-2 sub-heading">Engage & Collaborate</p>
                    <p style="color: #05709F;">Build partnerships and engage through messaging and webinars.</p>
                </div>
            </div>
            <div class="arrow d-flex justify-content-center align-items-center">
                <img src="../../assets/images/icons/about-us-right-icon.svg" class="arrowImage" style="padding-right: 10px;">
            </div>
            <div class="content-block">
                <img class="icon" src="../../../../assets/images/icons/showcase-your-products.svg" style="width: 48px;height: 48px;">
                <div class="content">
                    <p class="my-2 sub-heading">Showcase Your Products</p>
                    <p style="color: #05709F;">Upload your catalog and boost visibility to a global audience.</p>
                </div>
            </div>
            <div class="arrow d-flex justify-content-center align-items-center">
                <img src="../../assets/images/icons/about-us-right-icon.svg" class="arrowImage" style="padding-right: 10px;">
            </div>
            <div class="content-block">
                <img class="icon" src="../../../../assets/images/icons/stay-informed.svg" style="width: 48px; height: 48px;">
                <div class="content">
                    <p class="my-2 sub-heading">Stay Informed</p>
                    <p style="color: #05709F;">Access industry trends and insights to stay ahead of the competition.</p>
                </div>
            </div>
            <div class="down-arrow" style="padding-bottom: 0;">
                <img src="../../assets/images/about-us-down-arrow.svg"  style="margin: 0;">
            </div>
        </div>


    </div>
    <!-- <div class="d-flex align-items-center justify-content-center p-2">
        <div class="ready d-flex gap-2">
            <div>
                <img src="../../assets/images/about-us-ready.svg">
            </div>
            <div>
                <div class="heading">
                    Ready to talk? Get in touch with us
                </div>
                <div>
                    <p style="font-weight: 600;">Medworld Expo is dedicated to transforming how the medical industry connects, collaborates, and grows. Our digital platform offers unparalleled opportunities to reach a global audience, foster meaningful connections, and stay at the forefront of medical innovation. By joining Medworld Expo, you'll gain access to a vast network of professionals, cutting-edge tools, and a seamless, efficient way to showcase your products and services. </p>
                    <p style="font-weight: 600;">Take the first step towards revolutionizing your presence and become an integral part of the future of medical expos. For more information or assistance, please contact our support team. We are here to help you make the most of your Medworld Expo experience. </p>
                </div>
                <button class="btn d-flex align-items-center justify-content-center gap-2 py-2" style="background-color: #0D87C8; color: white; margin-top: 1em; ">
                    <img src="../../assets/images/icons/mail-icon.svg">
                    <span>Contact Us</span>
                </button>
            </div>
        </div>
    </div> -->


    <div class="ready-container  d-flex justify-content-center align-items-center">
        <div class="ready-to-talk d-flex">
            <div class="ready-image">
                <img src="../../assets/images/about-us-ready.svg" class="p-3">
            </div>
            <div class="heading-container d-flex flex-column justify-content-start" style="margin-top:29px">
                <div class="heading" style="margin-left: 0px;">
                    Ready to talk? Get in touch with us
                </div>
                <div class="d-flex flex-column gap-1 paragraph" style="margin-right:18px;">
                    <span class="paragraphs" style="text-align: justify;line-height: 1.4rem;">
                        Medworld Expo is dedicated to transforming how the medical industry connects,
                         collaborates, and grows. Our digital platform offers unparalleled opportunities to reach a global audience,
                          foster meaningful connections, and stay at the forefront of medical innovation. By joining Medworld Expo,
                          you'll gain access to a vast network of professionals, cutting-edge tools, and a seamless,
                          efficient way to showcase your products and services.
                    </span>
                    <span class="paragraphs" style="text-align: justify;line-height: 1.4rem;">
                        Take the first step towards revolutionizing your presence and become an integral part of
                        the future of medical expos. For more information or assistance, please contact our support team.
                        We are here to help you make the most of your Medworld Expo experience.
                    </span>
                </div>

                <button class="btn d-flex align-items-center justify-content-center gap-2" style="background-color: #0D87C8; color: white;margin-top: 10px;  width:160px;" routerLink="/contactus">
                    <img src="../../assets/images/icons/mail-icon.svg" height="24px" width="24px">
                    <span>Contact Us</span>
                </button>
            </div>
        </div>
    </div>

</div>
</div>
<app-website-footer></app-website-footer>
</div>